import {
  NOTIFICATION_EVENTS,
  NotificationStrategy,
  dispatchNotificationEvent,
  markAsAccepted,
  markAsRejected,
} from '../../../../shared/services/notification/workflow';

async function handleAccept({ item }: Parameters<NotificationStrategy['accept']>[0]) {
  await markAsAccepted(item.userNotificationId, item.status);

  dispatchNotificationEvent(NOTIFICATION_EVENTS.VIEW_REFRESH, {
    notificationId: item.notificationId,
    userNotificationId: item.userNotificationId,
    type: item.type,
    payload: item.payload,
  });
}

async function handleReject({ item }: Parameters<NotificationStrategy['reject']>[0]) {
  await markAsRejected(item.userNotificationId, item.status);
}

export const gridShareStrategy: NotificationStrategy = {
  accept: handleAccept,
  reject: handleReject,
};
